module.exports = __webpack_public_path__ + "ki.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ki.svg
// module id = 893
// module chunks = 0